import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { NOT_FOUND_URL } from '@yme/common/constants';
import { PARAMS_KEYS } from '@yme/organisms/test-ride-grid/constants';
export function useTestRideIframeError({ isInIframeError, languageRootPath, }) {
    const history = useHistory();
    useEffect(() => {
        if (isInIframeError && languageRootPath) {
            history.push({
                pathname: `${languageRootPath}/${NOT_FOUND_URL}`,
                search: `${PARAMS_KEYS.isIframe}=true`,
            });
        }
    }, [history, isInIframeError, languageRootPath]);
}
